import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocale } from '../../i18n/locale-context.js';
const MODAL_ORDER = [
    'patient-portal',
    'identity-provider',
    'passkey',
    'ai-agent',
    'in-person',
];
const MODAL_LABEL_KEYS = {
    'patient-portal': 'activation.identity_proofing.modal.patient_portal',
    'identity-provider': 'activation.identity_proofing.modal.identity_provider',
    passkey: 'activation.identity_proofing.modal.passkey',
    'ai-agent': 'activation.identity_proofing.modal.ai_agent',
    'in-person': 'activation.identity_proofing.modal.in_person',
};
export function PatientClaimingPathway(props) {
    const { t } = useLocale();
    return (_jsx("ul", { className: "shn-claiming-pathway-list", "aria-label": t('activation.identity_proofing.modal.list_aria_label'), "data-testid": "patient-claiming-pathway", children: MODAL_ORDER.map((modal) => (_jsx("li", { children: _jsxs("button", { type: "button", className: "shn-claiming-pathway-row", onClick: () => props.onSelect(modal), "data-testid": `patient-claiming-pathway-${modal}`, children: [_jsx("span", { children: t(MODAL_LABEL_KEYS[modal]) }), _jsx("span", { className: "shn-claiming-pathway-row__arrow", "aria-hidden": "true", children: "\u2192" })] }) }, modal))) }));
}
//# sourceMappingURL=patient-claiming-pathway.js.map